/* Review Carousel Continuous Loop for Desktop */

(function() {
  const MOBILE_BREAKPOINT = 991;
  const originalParentAttribute = 'data-original-parent';
  const clonedParentAttribute = 'data-cloned-parent';
  const clonedWrapperClass = 'review-carousel-wrapper-clone';
  let tries = 0;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function duplicateReviewContent(swiperContainer) {
    if (tries > 5) {
      return null;
    }

    tries++;
    if (swiperContainer.offsetWidth <= window.innerWidth + 100) {
      const firstSwiperItem = swiperContainer.querySelector('.swiper-slide.swiper-slide-active');
      if (!firstSwiperItem || !firstSwiperItem.style.width) {
        setTimeout(function() {
          duplicateReviewContent(swiperContainer);
        }, 500);
      } else {
        cloneContent(swiperContainer);
      }
    }
  }

  function cloneContent(swiperContainer) {
    const parentCopy = cloneParent(swiperContainer);
    hideOriginalParent();
    cloneSliderContent(parentCopy);
  }

  function hideOriginalParent() {
    const originalParent = document.querySelector('[' + 'data-original-parent' + ']');
    if (originalParent) {
      originalParent.style.display = 'none';
    }
  }

  function cloneParent(swiperContainer) {
    const currentParent = swiperContainer.parentNode;
    currentParent.setAttribute(originalParentAttribute, true);
    const parentCopy = currentParent.cloneNode(true);
    parentCopy.setAttribute(clonedParentAttribute, true);
    currentParent.parentNode.appendChild(parentCopy);

    return parentCopy;
  }

  function cloneSliderContent(parentCopy) {
    const swiperContainer = parentCopy.querySelector('.swiper-wrapper');
    const swiperContainerCopy = swiperContainer.cloneNode(true);
  
    const newParent = document.createElement('div');
    newParent.style.cssText = 'display: flex; animation: slide-left 30s linear infinite;';
    newParent.className = clonedWrapperClass;
    parentCopy.replaceChild(newParent, swiperContainer);

    newParent.appendChild(swiperContainer);
    newParent.appendChild(swiperContainerCopy);
  }

  function restoreDefaultWrapper(swiperContainer, clonedWrapper) {
    const clonedParent = document.querySelector('[' + clonedParentAttribute + ']');
    clonedParent.remove();
    const originalParent = document.querySelector('[' + originalParentAttribute + ']');
    originalParent.style.display = 'flex';
  }

  function updateWidths() {
    const sectionWrapper = document.querySelector('.rbsv3-reviews-carousel__inner');
    if (!sectionWrapper) {
      return;
    }

    const newWidth = sectionWrapper.clientWidth / 4;
    const clonedSliderContent = document.querySelectorAll('[' + clonedParentAttribute + ']' + ' .swiper-slide');
    [...clonedSliderContent].forEach((content) => {
      content.style.width = newWidth.toString() + 'px';
    });
  }

  function handleResize() {
    const sectionContainer = document.querySelector('.faq-carousel');
    if (!sectionContainer) {
      return null;
    }

    const swiperContainer = sectionContainer.querySelector(':not(.rbsv3-reviews-carousel__preview-mobile) > .swiper-wrapper');
    if (!swiperContainer) {
      return null;
    }
    
    if (isMobile()) {
      // Restore default wrapper if cloned wrapper exists
      const clonedWrapper = document.querySelector('.' + clonedWrapperClass);
      if (clonedWrapper) {
        restoreDefaultWrapper(swiperContainer, clonedWrapper);
      }
    } else {
      // Initialize cloned wrapper if not already initialized
      const clonedWrapper = document.querySelector('.' + clonedWrapperClass);
      if (!clonedWrapper) {
        tries = 0;
        duplicateReviewContent(swiperContainer);
      } else {
        updateWidths();
      }
    };
  }

    // Initialize on DOM ready
  function init() {
    function setupResizeHandler() {
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 250);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        handleResize();
        setupResizeHandler();
      });
    } else {
      setTimeout(function() {
        handleResize();
        setupResizeHandler();
      }, 0);
    }
  }

  init();
})();